import React, { PropsWithoutRef } from "react"
import { useField } from "react-final-form"
import { useId } from "@reach/auto-id"
import { HiSearch } from "react-icons/hi"

export interface SearchFieldProps extends PropsWithoutRef<JSX.IntrinsicElements["input"]> {
  /** Field name. */
  name: string
  /** Field label. */
  label?: string
  outerProps?: PropsWithoutRef<JSX.IntrinsicElements["div"]>
}

export const SearchField = React.forwardRef<HTMLInputElement, SearchFieldProps>(
  ({ name, label = "Search", outerProps, ...props }, ref) => {
    const {
      input,
      meta: { submitting },
    } = useField(name)
    const id = useId() + "name"

    return (
      <div {...outerProps}>
        <label htmlFor={id} className="sr-only">
          {label}
        </label>
        <div className="relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <HiSearch className="mr-3 h-4 w-4 text-gray-400" />
          </div>
          <input
            className="form-input block w-full pl-9 sm:text-sm sm:leading-5"
            placeholder={label}
            type="text"
            id={id}
            key={id}
            disabled={submitting}
            ref={ref}
            {...input}
            {...props}
          />
        </div>
      </div>
    )
  }
)

export default SearchField
